import React, { useMemo } from "react";
import { Tooltip } from "@material-ui/core";
import InfoIcon from "../../assets/images/info-icon.svg";
import NetworkElementInputRow from "./networkElementInputRow";
import FormFieldBox from "../DesignSystem/formFieldBox";
import Input from "../DesignSystem/input";

interface NetworkElementBottomSectionProps {
  portsInfo: any;
  onPortNameChange: (portTempId: number, portName: string) => void;
  onKeypress: (_: any) => void;
  link?: boolean;
  isValidPortName: ((_: string) => boolean) | undefined;
  portPrefix: string;
  handlePortPrefixChange: (_: string) => void;
}

const NetworkElementBottomSection: React.FC<NetworkElementBottomSectionProps> = ({
  portsInfo,
  onPortNameChange,
  onKeypress,
  link,
  isValidPortName,
  portPrefix,
  handlePortPrefixChange,
}) => {
  const networkElementInputRows = useMemo(() => {
    return portsInfo.map((portInfo: any, index: number) => {
      return (
        <NetworkElementInputRow key={index} portInfo={portInfo} onPortNameChange={onPortNameChange} onKeypress={onKeypress} isValidPortName={isValidPortName} />
      );
    });
  }, [onKeypress, onPortNameChange, portsInfo]);

  return (
    <div className="bottom-section-root">
      <FormFieldBox excludeMarginTop excludeMarginBottom>
        <div className="text-area-root">
          <div>
            <label>
              {link ? "Link Prefix" : "Port Prefix"}
              <span className="asterisk">*</span>
            </label>
            <Tooltip
              classes={{
                tooltip: "tooltip",
              }}
              title="Enter the integer number of ports to be added which share a common description. When adding more that one port, ports will be automatically grouped on the dashboard page."
              arrow
              placement="right-start"
            >
              <img src={InfoIcon} alt="Info" />
            </Tooltip>
          </div>
          <div className="input-row">
            <div>
              <div>
                <Input
                  variant="input"
                  value={portPrefix}
                  errorMessageClass="small-fonts"
                  onChange={handlePortPrefixChange}
                  name="prefix"
                  className="port-name d-input-bandwidth"
                  onKeypress={onKeypress}
                />
              </div>
            </div>
          </div>
        </div>
      </FormFieldBox>

      <div className="input-row-titles">
        <div>
          <label>
            {link ? "Link" : "Port"}
            <span className="asterisk">*</span>
          </label>
          <Tooltip
            classes={{
              tooltip: "tooltip",
            }}
            title={`Enter a unique identifier for each individual ${link ? "link" : "port"}. Example: ${link ? "Link" : "Port"} 1”`}
            arrow
            placement="top"
          >
            <img src={InfoIcon} alt="Info" />
          </Tooltip>
        </div>
      </div>
      <div className="input-row-inputs">{networkElementInputRows}</div>
    </div>
  );
};

export default NetworkElementBottomSection;
